import React from 'react';

export function Card({
  title,
  children,
  style,
  className,
  onClick,
}: {
  title?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  onClick?: () => void;
}) {
  return (
    <section className={className ? `card ${className}` : 'card'} style={style} onClick={onClick}>
      {title ? <h2 className="cardTitle">{title}</h2> : null}
      <div>{children}</div>
    </section>
  );
}

